import { type ComponentProps, type ReactNode } from 'react'

import { AdLeaderboard, AdMidBanner } from '@/components/common/Ad'
import { Splash } from '@/components/common/Splash'
import { useAds } from '@/components/providers/AdsProvider'
import { cn } from '@/utils/commonUtil'

import styles from './FeaturedCommonRoot.module.scss'

type Props = {
  backgroundImages?: string[]
  children?: ReactNode
  leaderboardDisabled?: boolean
  midBannerDisabled?: boolean
  splashProps?: ComponentProps<typeof Splash>
}

export const FeaturedCommonRoot = ({
  backgroundImages,
  children,
  leaderboardDisabled: leaderboardDisabledProp,
  midBannerDisabled: midBannerDisabledProp,
  splashProps,
}: Props) => {
  const ads = useAds()

  const sidebarDisabled = ads.sidebarDisabled
  const leaderboardDisabled = ads.leaderboardDisabled || leaderboardDisabledProp
  const midBannerDisabled = ads.midBannerDisabled || midBannerDisabledProp

  return (
    <section className={cn(styles.container, { leaderboardDisabled, midBannerDisabled, sidebarDisabled, styles })}>
      <Splash backgroundImages={backgroundImages} isAboveFold variant='featured' {...splashProps} />
      <div className={styles.inner}>
        {!leaderboardDisabled && (
          <div className={styles.adLeaderboard}>
            <AdLeaderboard />
          </div>
        )}
        <div className={styles.content}>{children}</div>
        {!midBannerDisabled && (
          <div className={styles.adMidBanner}>
            <AdMidBanner />
          </div>
        )}
      </div>
    </section>
  )
}
